export const activityTypes = {
    UserLogin: "UserLogin",
    LaunchDashboard: "LaunchDashboard",
    LaunchDashboardViaLink: "LaunchDashboardViaLink",
    WikiArticleOpened: "WikiArticleOpened",
    Navigation: "Navigation"
}